import React from 'react';
import { Sparkles } from 'lucide-react';
import AgentLanding from '../../agents/shared/AgentLanding';
import { incidentAnalystSpec } from './spec';

const IncidentAnalystPage: React.FC = () => {
  return (
    <div className="max-w-[1400px] mx-auto">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-cargo-text flex items-center gap-2">
          <Sparkles className="w-6 h-6 text-cargo-accent" />
          Incident Analyst
        </h1>
        <p className="text-cargo-muted mt-1">
          Investigate open incidents in chat — lineage walk, root cause, blast radius
        </p>
      </div>
      <AgentLanding spec={incidentAnalystSpec} />
    </div>
  );
};

export default IncidentAnalystPage;
